<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <section class="modal-card-body">
        <div class="claim">
          <div class="header">รับรางวัล</div>
          <div>
            {{ coupon.prize.slice.label }}
          </div>

          <div
            v-if="coupon.prize.slice.htmlDescription"
            class="free-credit-notice"
            v-html="coupon.prize.slice.htmlDescription"
          ></div>

          <div class="box-button m-t-30">
            <button
              class="button full-50 is-light"
              aria-label="cancel"
              @click="cancelModal"
            >
              ยกเลิก
            </button>
            <button
              class="button full-50 is-primary"
              aria-label="confirm"
              @click="confirmModal"
            >
              ยืนยัน
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiSpin from '@/api/spin'
import i18n from '@/language'
import _ from 'lodash'

export default {
  name: 'ModalClaim',
  components: {},
  props: {
    coupon: {
      type: Object
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  methods: {
    confirmModal: _.debounce(async function() {
      const result = await apiSpin.claimCoupon(this.coupon)
      if (result.success) {
        this.$swal(
          i18n.t('spin.claimPrizeSuccess'),
          i18n.t('spin.receive', {
            label: this.coupon.prize.slice.label
          }),
          'success'
        )
      } else {
        this.$swal(
          i18n.t('modals.errorMsg'),
          i18n.t(`spin.error.${result.error}`),
          'error'
        )
      }

      this.$emit('confirmModal', null)
    }, 500),
    cancelModal() {
      this.$emit('cancelModal', null)
    }
  }
}
</script>

<style scoped lang="scss">
.claim {
  color: black;
  margin-top: 10px;
  text-align: center;

  .header {
    font-size: 20px;
    font-weight: 600;
  }

  .free-credit-notice {
    margin-top: 10px;
    font-size: 14px;
  }
}

.modal-card-body {
  border-radius: 20px;
  width: 80%;
  margin: auto;
}

.confirm {
  margin-top: 10px;
}
</style>
